import api from 'api';
import { mapToRecords } from 'records/CustomSize';

export const SET_CUSTOM_SIZE_RECORDS = 'SET_CUSTOM_SIZE_RECORDS';
export const UPDATE_CUSTOM_SIZE_RECORD = 'UPDATE_CUSTOM_SIZE_RECORD';
export const UPDATE_ALL_CUSTOM_SIZE_RECORDS = 'UPDATE_ALL_CUSTOM_SIZE_RECORDS';
export const RESET_CUSTOM_SIZE_RECORDS = 'RESET_CUSTOM_SIZE_RECORDS';
export const CUSTOM_SIZE_ACTION_START = 'CUSTOM_SIZE_ACTION_START';
export const CUSTOM_SIZE_ACTION_FAILURE = 'CUSTOM_SIZE_ACTION_FAILURE';
export const CUSTOM_SIZE_ACTION_FINISH = 'CUSTOM_SIZE_ACTION_FINISH';

const genericErrorMessage = 'An Error Occured';

/**
 * set loading state
 * @returns
 */
export const customSizeActionStart = () => ({
    type: CUSTOM_SIZE_ACTION_START,
});

/**
 * finish loading state
 * @returns
 */
export const customSizeActionFinish = () => ({
    type: CUSTOM_SIZE_ACTION_FINISH,
});

/**
 * end loading on errors
 * @param {String} message error message
 * @returns 
 */
export const customSizeActionFailure = message => ({
    type: CUSTOM_SIZE_ACTION_FAILURE,
    data: { message },
});

/**
 * Initiates set custom-size action
 * @param {Array} data list of custom size records
 * @returns 
 */
export const setCustomSizeData = data => ({
    type: SET_CUSTOM_SIZE_RECORDS,
    data,
});

/**
 * Update all the custom design dimension pages
 * @param {Object} param0 design dimensions
 * @returns 
 */
export const updateAllCustomDesignDimensionPages = ({ width, height, isBleedEnabled }) => ({
    type: UPDATE_ALL_CUSTOM_SIZE_RECORDS,
    data: { width, height, isBleedEnabled },
});

/**
 * resets the state
 * @returns
 */
export const resetCustomSizeRecords = () => ({
    type: RESET_CUSTOM_SIZE_RECORDS,
});

/**
 * Create a custom-size record
 * @param {Object} param0 custom size dimensions
 * @returns 
 */
export function createCustomSizeRecordAsync({ width, height, isBleedEnabled, designId }) {
    return (dispatch, getState) => {
        
        dispatch(customSizeActionStart());
        return api.request('design/custom-size', 'post', { width, height, isBleedEnabled, designId })
            .then(() => dispatch(customSizeActionFinish()))
            .catch(err => {
                dispatch(customSizeActionFailure(genericErrorMessage));
                throw err;
            });
    };
}

/**
 * fetches the custom-size data by designId
 * @param {Number} designId design id
 * @returns 
 */
export function fetchCustomSizeRecordAsync(designId) {
    return (dispatch, getState) => {
        

        dispatch(customSizeActionStart());
        return api.request(`design/custom-size/${designId}`, 'get')
            .then(data => {
                dispatch(setCustomSizeData(data));
                return mapToRecords(data);
            })
            .catch(err => {
                dispatch(customSizeActionFailure(genericErrorMessage));
                throw err;
            });
    };
}

/**
 * replicate a new custom design page
 * @param {Object} pageInfo page information
 * @returns 
 */
export function addCustomDesignPageAsync(pageInfo) {
    return (dispatch, getState) => {
        
        dispatch(customSizeActionStart());
        return api.request('design/custom-size/addDesignPage', 'post', pageInfo)
            .then(() => dispatch(customSizeActionFinish()))
            .catch(err => {
                dispatch(customSizeActionFailure(genericErrorMessage));
                throw err;
            });
    };
}

/**
 * Delete a custom design page
 * @param {Number} designId design id
 * @param {Number} pageId page id
 * @param {Object} pageInfo page information
 * @returns 
 */
export function deleteCustomDesignPageAsync(designId, pageId, pageInfo) {
    return (dispatch, getState) => {
        
        dispatch(customSizeActionStart());
        return api.request(`design/custom-size/${designId}/pages/${pageId}`, 'delete', pageInfo)
            .then(() => dispatch(customSizeActionFinish()))
            .catch(err => {
                dispatch(customSizeActionFailure(genericErrorMessage));
                throw err;
            });
    };
}

/**
 * update customer design
 * @param {Number} designId design id
 * @param {Array} designInfo design dimensional info
 * @returns 
 */
export function updateCustomDesignAsync(designId, designInfo) {
    return (dispatch, getState) => {
        
        dispatch(customSizeActionStart());
        return api.request(`design/custom-size/${designId}`, 'put', designInfo)
            .then(data => dispatch(setCustomSizeData(data)))
            .catch(err => {
                dispatch(customSizeActionFailure(genericErrorMessage));
                throw err;
            });
    };
}
